import React, { useContext } from 'react';
import { emptySearchBlock, GlobalStateContext } from '../wrappers/GlobalContext';
import SearchField from './SearchField';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, IconButton, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';
import useSearch from '../hooks/useSearch';
import navbar_background from '../assets/navbar_background.svg';



type Props = {
  open: boolean,
  onClose: (() => void)
}

function AssistedSearch({ open, onClose }: Props) {
  const { searchValues, setSearchValues, clearSearch } = useContext(GlobalStateContext);
  const { searchTerm, setSearchTerm,} = useContext(GlobalStateContext);
  const { typedDescription, setTypedDescription } = useContext(GlobalStateContext);

  const { typedDescriptionOverprice, setTypedDescriptionOverprice } = useContext(GlobalStateContext);
  const { searchTermOverprice, setSearchTermOverprice,} = useContext(GlobalStateContext);

  const { buildQuery } = useSearch()


  const removeInput = (blockIndex: number, i: number) => {
    const data = [...searchValues];
    data[blockIndex].searchValues = data[blockIndex].searchValues.filter((item, index) => i !== index);
    setSearchValues(data);
    setTypedDescription(buildQuery());
    setTypedDescriptionOverprice(buildQuery());
  }

  const updateSearchValue = (blockIndex: number, index: number, newData: SearchValue) => {
    const data = [...searchValues];
    data[blockIndex].searchValues[index] = newData;
    setSearchValues(data);
    setSearchTerm(buildQuery());    
    setSearchTermOverprice(buildQuery());  
  }

  const addInput = (blockIndex: number) => {
    const newData = [...searchValues];
    newData[blockIndex].searchValues.push({
      mapping: "at-least-one",
      operator: "or",
      query: ""
    });
    setSearchValues(newData)
    setSearchTerm(buildQuery());  
    setSearchTermOverprice(buildQuery());  
  }

  const addBlock = () => {
    const newData = [...searchValues];
    newData.push({
      operator: "or",
      searchValues: [
        {
          operator: "or",
          mapping: "at-least-one",
          query: ""
        }
      ]
    });

    setSearchValues(newData);
    setSearchTerm(buildQuery());
    setSearchTermOverprice(buildQuery());  
    }

  const changeBlockOperator = (blockIndex: number, event: SelectChangeEvent) => {
    const newData = [...searchValues];
    newData[blockIndex].operator = event.target.value as string;
    setSearchValues(newData);
    setSearchTerm(buildQuery()); 
    setSearchTermOverprice(buildQuery());   
  }

  const removeBlock = (blockIndex: number) => {
    const newData = [...searchValues];
    newData.splice(blockIndex, 1);
    setSearchValues(newData);
    setSearchTerm(buildQuery()); 
    setSearchTermOverprice(buildQuery());  
   }

  return (<>
    <Dialog
      open={open}
      onClose={() => onClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="md"
    >
      <DialogTitle id="alert-dialog-title" color='white' sx={{bgcolor: '#00617b' , backgroundImage: `url(${navbar_background})`, backgroundSize: "cover"  ,display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {"Busca Assistida"}
        <IconButton onClick={() => onClose()}>
          <CloseIcon sx={{color: 'white'}} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {searchValues.map((block, blockIndex) =>
          <>
            {blockIndex > 0 &&
              <div className="my-4 flex items-center justify-center gap-2">

                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={block.operator}
                  onChange={(v) => changeBlockOperator(blockIndex, v)}
                  size='small'
                >
                  <MenuItem value="and">E também (AND)</MenuItem>
                  <MenuItem value="or">Ou (OR)</MenuItem>
                </Select>

                <IconButton aria-label="delete" color="error" onClick={() => removeBlock(blockIndex)}>
                  <RemoveCircleIcon />
                </IconButton>

              </div>
            }
            <div className="flex flex-col gap-2 mt-2 w-full">
              {block.searchValues.map((item, i) =>
                <SearchField
                  key={`${blockIndex}_${i}`}
                  blockIndex={blockIndex}
                  index={i}
                  first={i === 0}
                  count={block.searchValues.length}
                  data={item}
                  onRemove={() => removeInput(blockIndex, i)}
                  onChange={updateSearchValue}
                />
              )}
            </div>
            <div className="my-2 text-right">
              <Button
                onClick={() => addInput(blockIndex)}
                size='small'
                variant="outlined"
                startIcon={<AddCircleIcon />}
              >
                Adicionar termo
              </Button>
            </div>
          </>
        )}

        <div className="my-2 text-right">
          <Button
            onClick={addBlock}
            size='small'
            variant="outlined"
            startIcon={<AddCircleIcon />}
          >
            Adicionar bloco
          </Button>
        </div>

        <div className="my-2 text-right">

        </div>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={clearSearch}
          color='error'
          startIcon={<DeleteIcon />}
          variant='contained'
          size='small'
        >
          Limpar busca
        </Button>
        <Button
          onClick={() => onClose()}
          variant='contained'
          size='small'
        >
          OK
        </Button>
      </DialogActions>

    </Dialog>

  </>);
}

export default AssistedSearch;
